export default async function authFetch(url, options = {}) {
  const token = localStorage.getItem('token');
  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  let data = {};
  try { data = await res.json(); } catch {}
  if (!res.ok || !data.success) {
    const err = new Error(data.error || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  // options.full: devolve o envelope inteiro ({ data, meta, ... }) em vez de
  // só data.data. Usado pelas rotas de histórico paginadas por cursor, que
  // carregam next_cursor/has_more em meta — todo o resto do app continua
  // recebendo só data.data, sem mudança de comportamento.
  return options.full ? data : data.data;
}
